import React, { useEffect, useState } from 'react'
import Banner from './components/Banner/Index'
// import pageData from './Json/Sustainibility.json'
import Overview from './components/Aboutus/Overview';
import ProListing from './components/Products/ProListing';
import axios from 'axios';
import { API_BASE_URL } from "./Utils/useApi";
import { CircularProgress } from "@mui/material";

const Sustainibility = () => {
  const [pageData, setPageData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/sustainability.php`);
        setPageData(response.data);
      }
      catch (err) {
        setError(err.message);
      }
      finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);
  if (loading) return (
    <div className="preloader flex-center">
      <CircularProgress size={24} />
    </div>
  );
  if (error) return (
    <div>Error: An error occurred while fetching data</div>
  )
  const { bannerData, overview, sustainibilityData } = pageData;
  return (
    <>
      <Banner Data={bannerData[0]} />
      {overview && <Overview Data={overview} _class={'text-lg-center text-start'}/>}
      {
        sustainibilityData &&
        <ProListing Data={sustainibilityData} servicePage={true} listingClass={'servicePage fullDescp'} />
      }
    </>
  )
}

export default Sustainibility